export const PRODUCTS_PER_PAGE = 12;
export const PRODUCTS_PAGINATION_MAX_PAGE_VISIBLE_DESKTOP = 5;
export const PRODUCTS_PAGINATION_MAX_PAGE_VISIBLE_MOBILE = 5;

export const BUNDLE_TYPE = 'StaticBundleParent';
export const BUNDLE_TYPE_ATTR_KEY = '_ProductType';

export const BUNDLE_LABEL_ATTR_KEY = 'product-label';

export const BUNDLE_PRODUCTS_ATTR_KEY = 'products';

export const BUNDLE_LABEL_DEFAULT_LOCALE = 'fr';

export const BUNDLE_MERCH_LABEL_KEY = 'bundleLabel';

export enum GiftingTypeFields {
  Rejected = 'rejected',
}
